(function () {
  var nav = document.querySelector('[data-bic-tier-nav]');
  if (!nav) return;

  var toggle = nav.querySelector('[data-bic-tier-nav-toggle]');
  var menu = nav.querySelector('[data-bic-tier-nav-menu]');
  var links = Array.prototype.slice.call(nav.querySelectorAll('[data-bic-tier-nav-link]'));

  // --- Popover toggle: a non-intrusive "Browse series" button ---
  if (toggle && menu) {
    function onDocClick(e) {
      if (!nav.contains(e.target)) close();
    }
    function onKey(e) {
      if (e.key === 'Escape') { close(); toggle.focus(); }
    }
    function open() {
      menu.hidden = false;
      nav.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      document.addEventListener('click', onDocClick, true);
      document.addEventListener('keydown', onKey);
    }
    function close() {
      menu.hidden = true;
      nav.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', onDocClick, true);
      document.removeEventListener('keydown', onKey);
    }
    toggle.addEventListener('click', function () {
      if (toggle.getAttribute('aria-expanded') === 'true') close(); else open();
    });
    links.forEach(function (link) {
      link.addEventListener('click', function () { close(); });
    });
  }

  // --- Scrollspy: mark the active series link while scrolling ---
  if ('IntersectionObserver' in window && links.length) {
    var pairs = [];
    links.forEach(function (link) {
      var href = link.getAttribute('href') || '';
      if (href.charAt(0) !== '#' || href.length < 2) return;
      var target = document.getElementById(href.slice(1));
      if (target) pairs.push({ link: link, target: target });
    });
    if (pairs.length) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          links.forEach(function (l) { l.classList.remove('is-active'); });
          var match = pairs.filter(function (p) { return p.target === entry.target; })[0];
          if (match) match.link.classList.add('is-active');
        });
      }, { rootMargin: '-25% 0px -65% 0px', threshold: 0 });
      pairs.forEach(function (p) { observer.observe(p.target); });
    }
  }
})();
